import { FrontPageNotifications } from '../objects/FrontPageNotifications';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class NotificationEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this._url = url;
        this._api = api;
    }

    getFrontPagenotifications() {
        return this._api.getResponse(this._url + '/frontpage')
            .then(rsp => new FrontPageNotifications(rsp.getResult(), rsp.context));
    }
}
